import { LoadableAfterPaint } from '@confluence/loadable';

export const BylineConnections = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BylineConnections" */ '../src/BylineConnections.tsx'
			)
		).BylineConnections,
});
